import { render, staticRenderFns } from "./FeedInfo.vue?vue&type=template&id=58d473f6&scoped=true"
import script from "./FeedInfo.vue?vue&type=script&lang=js"
export * from "./FeedInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d473f6",
  null
  
)

export default component.exports